import { render, staticRenderFns } from "./TransferListOwnership.vue?vue&type=template&id=fe8a1178&scoped=true"
import script from "./TransferListOwnership.vue?vue&type=script&lang=js"
export * from "./TransferListOwnership.vue?vue&type=script&lang=js"
import style0 from "./TransferListOwnership.vue?vue&type=style&index=0&id=fe8a1178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8a1178",
  null
  
)

export default component.exports